/* Activate the matching Shopify rules before publishing this theme. */
window.ur_box_discount_config = {
  "version": 2,
  "rules": [
    {
      "target": 6,
      "cans": 1,
      "cookies": 0,
      "percent": 0,
      "canCode": "URBOX-RGS9S368",
      "cookieCode": "",
      "percentCode": "",
      "giftCode": "URBOX-RGS9S368"
    },
    {
      "target": 12,
      "cans": 2,
      "cookies": 0,
      "percent": 0,
      "canCode": "URBOX-6MJ52367",
      "cookieCode": "",
      "percentCode": "",
      "giftCode": "URBOX-6MJ52367"
    },
    {
      "target": 18,
      "cans": 2,
      "cookies": 1,
      "percent": 0,
      "canCode": "URBOX-P9MGFZLX",
      "cookieCode": "URBOX-GNRRU7BL",
      "percentCode": "",
      "giftCode": "URBOX-Z6QTJNAU"
    },
    {
      "target": 24,
      "cans": 3,
      "cookies": 1,
      "percent": 0,
      "canCode": "URBOX-TTQG2XSL",
      "cookieCode": "URBOX-TXCHFFAF",
      "percentCode": "",
      "giftCode": "URBOX-R862VX7E"
    },
    {
      "target": 30,
      "cans": 4,
      "cookies": 1,
      "percent": 0,
      "canCode": "URBOX-4TLZ9VHV",
      "cookieCode": "URBOX-KBX49LHU",
      "percentCode": "",
      "giftCode": "URBOX-2G4EXLFL"
    },
    {
      "target": 36,
      "cans": 4,
      "cookies": 2,
      "percent": 0,
      "canCode": "URBOX-K8D477XP",
      "cookieCode": "URBOX-ZWDFB5QQ",
      "percentCode": "",
      "giftCode": "URBOX-MY5EF3QZ"
    },
    {
      "target": 42,
      "cans": 5,
      "cookies": 2,
      "percent": 0,
      "canCode": "URBOX-ZFGS8SHC",
      "cookieCode": "URBOX-ZCFMSZP4",
      "percentCode": "",
      "giftCode": "URBOX-PQK978R3"
    },
    {
      "target": 48,
      "cans": 5,
      "cookies": 2,
      "percent": 5,
      "canCode": "URBOX-HTCRXQ3D",
      "cookieCode": "URBOX-7S9DG76S",
      "percentCode": "URBOX-5CVCMMMK",
      "giftCode": "URBOX-FWYAP7VF"
    },
    {
      "target": 54,
      "cans": 8,
      "cookies": 2,
      "percent": 5,
      "canCode": "URBOX-RJ4WWCCL",
      "cookieCode": "URBOX-C3FUR4X9",
      "percentCode": "URBOX-5MVTYN8A",
      "giftCode": "URBOX-P35X5ZCT"
    },
    {
      "target": 60,
      "cans": 8,
      "cookies": 2,
      "percent": 10,
      "canCode": "URBOX-AVNLRJ44",
      "cookieCode": "URBOX-XF8CE5ZH",
      "percentCode": "URBOX-PRJ9FTZQ",
      "giftCode": "URBOX-C7S983LW"
    }
  ],
  "giftVariants": {
    "41358727250083": {
      "variantId": "59366743310600",
      "productId": "12421396070664",
      "handle": "ur-futterbox-zugabe-rindermenu-abo-400g"
    },
    "41358727905443": {
      "variantId": "59366732529928",
      "productId": "12421390106888",
      "handle": "ur-futterbox-zugabe-wild-400g"
    },
    "41358695366819": {
      "variantId": "59366743343368",
      "productId": "12421396103432",
      "handle": "ur-futterbox-zugabe-geflugelmenu-abo-400g"
    },
    "41358680522915": {
      "variantId": "59366743376136",
      "productId": "12421396136200",
      "handle": "ur-futterbox-zugabe-entenmenu-abo-400g"
    },
    "42322734776483": {
      "variantId": "59366743408904",
      "productId": "12421396168968",
      "handle": "ur-futterbox-zugabe-pferd-mit-karotte-und-quinoa-400g"
    },
    "41358721384611": {
      "variantId": "59366743441672",
      "productId": "12421396201736",
      "handle": "ur-futterbox-zugabe-lachsmenu-abo-400g"
    },
    "45162250895624": {
      "variantId": "59366743474440",
      "productId": "12421396234504",
      "handle": "ur-futterbox-zugabe-lamm-400g"
    },
    "54101959180552": {
      "variantId": "59366743507208",
      "productId": "12421396267272",
      "handle": "ur-futterbox-zugabe-kaninchenmenu-400g"
    }
  }
};
window.ur_promo_breaks = [
  {
    "target": 6,
    "couponType": "400g_can_free",
    "amount": 1,
    "text": "Noch {COUNTER} Dosen bis zu einer Gratisdose."
  },
  {
    "target": 12,
    "couponType": "400g_can_free",
    "amount": 1,
    "text": "Noch {COUNTER} Dosen bis 2 Gratisdosen."
  },
  {
    "target": 18,
    "couponType": "200g_cookies_free",
    "amount": 1,
    "text": "Noch {COUNTER} Dosen bis zu einer Gratispackung Hundekekse."
  },
  {
    "target": 24,
    "couponType": "400g_can_free",
    "amount": 1,
    "text": "Noch {COUNTER} Dosen bis 3 Gratisdosen."
  },
  {
    "target": 30,
    "couponType": "400g_can_free",
    "amount": 1,
    "text": "Noch {COUNTER} Dosen bis 4 Gratisdosen."
  },
  {
    "target": 36,
    "couponType": "200g_cookies_free",
    "amount": 1,
    "text": "Noch {COUNTER} Dosen bis 2 Gratispackungen Hundekekse."
  },
  {
    "target": 42,
    "couponType": "400g_can_free",
    "amount": 1,
    "text": "Noch {COUNTER} Dosen bis 5 Gratisdosen."
  },
  {
    "target": 48,
    "couponType": "percent_discount",
    "amount": 5,
    "text": "Noch {COUNTER} Dosen bis 5 % Mengenrabatt."
  },
  {
    "target": 54,
    "couponType": "400g_can_free",
    "amount": 3,
    "text": "Noch {COUNTER} Dosen bis 8 Gratisdosen."
  },
  {
    "target": 60,
    "couponType": "percent_discount",
    "amount": 10,
    "text": "Noch {COUNTER} Dosen bis 10 % Mengenrabatt."
  }
];
